<!-- One LINE store thumbnail at native px. Square-edged: the store rounds its
     own corners; the workbench adds a review-only radius from the outside. -->
<div class="thumb"
     [style.width.px]="w"
     [style.height.px]="h"
     [style.--s]="s"
     [style.--panel]="panel"
     [style.--panel-0]="panel0"
     [style.--fg]="fg"
     [style.--fg-dim]="fgDim"
     [style.--accent]="accent">

  <!-- The theme's own wallpaper fills the canvas. -->
  <img class="thumb-bg" *ngIf="wallpaper" [src]="wallpaper" alt="" aria-hidden="true">

  <!-- Same-colour scrim pooling at the bottom: white-ish on Light themes,
       near-black on Dark, so the identity stack always reads. -->
  <div class="thumb-scrim"></div>

  <!-- Decorative Codigrate logo half at the bottom-left (like the compact
       theme card), in the theme's own colour gradient. -->
  <svg class="thumb-part thumb-part--left"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
       viewBox="0 0 210 297" aria-hidden="true">
    <defs>
      <linearGradient
        y2="165.93872" x2="224.92535" y1="169.14873" x1="124.6287"
        gradientTransform="matrix(-3.8992867,0,0,3.8992867,887.45881,-514.3054)"
        gradientUnits="userSpaceOnUse"
        [id]="'lg_thumb_r_' + uid"
        [attr.xlink:href]="'#lgc_thumb_r_' + uid"/>
      <linearGradient
        x1="0" y1="0" x2="1" y2="0"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(135.46671,0,0,-135.46671,1268.2878,631.59055)"
        spreadMethod="pad"
        [id]="'lgc_thumb_r_' + uid">
        <stop [attr.stop-color]="accent2" offset="0"/>
        <stop [attr.stop-color]="accent" offset="1"/>
      </linearGradient>
    </defs>
    <path
      [style.fill]="'url(#lg_thumb_r_' + uid + ')'"
      style="fill-opacity:1;stroke:none;stroke-width:3.8232"
      d="M 31.496131,83.498219 C 17.281586,96.049685 13.920954,122.9803 24.61827,138.63631 v 0 c 8.67477,16.8641 33.95747,26.73174 51.762024,20.2132 v 0 l 54.361716,54.36558 -83.532627,83.53647 60.446297,8e-5 84.02015,-83.53655 -84.82866,-84.83262 C 113.3695,110.57782 103.49808,85.295107 86.634028,76.620298 v 0 C 80.390777,72.357466 72.362085,70.323536 64.161412,70.323536 v 0 c -12.368001,0 -25.118271,4.626039 -32.665281,13.174683"/>
  </svg>

  <!-- The logo floats high in the clear wallpaper area, over the scrim fade. -->
  <img class="thumb-logo" *ngIf="logo" [src]="logo" [alt]="name">

  <!-- Identity stack on the scrim: CATEGORY, LIGHT|DARK (the dash is the
       theme-colour line, like the theme card) / name / tags. -->
  <div class="thumb-content">
    <span class="thumb-category" *ngIf="category">{{ category }}<ng-container *ngIf="appearance"><span class="thumb-dash"></span>{{ appearance }}</ng-container></span>
    <h4 class="thumb-name">{{ name }}</h4>
    <span class="thumb-tags" *ngIf="tags">{{ tags }}</span>
  </div>
</div>
